import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import template from './mobile-nav-bar.html';
import homeIcon from './../../../images/secondary-pages-logo.png';

@Component({
  controllerAs: 'mobileNav',
  template
})

export default class MobileNavBar {

  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    '$cookies'

  ];

  constructor($scope, $ngRedux, $state, $auth, $cookies) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.logoIcon = logoIcon;
    this.$auth = $auth;
    let guestStore = null;
    this.homeIcon = homeIcon;
    try {
      guestStore = sessionStorage.getItem('guestStoreName');
    }
    catch (e) {
      guestStore = $cookies.get('guestStoreName');
    }
    this.$auth.getStoreDetail(guestStore);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {

    let obj = {
      profile: state.auth.profile,
      list: state.order.categories
    };
    if (!obj.profile.store) {
      obj.profile = {'store': state.auth.storeDetail};
    }
    return obj;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/mobile-nav-bar/mobile-nav-bar.js